
<template>

  <TemplateBasic 
    v-bind:breadcrumb="breadcrumb"
    v-bind:permission="permission">
    
    <AppFilter 
      ref="carparkFilter" 
      filterKey="carparkID"
      v-on:filter-data-change="onFilterCarparkChange" />

    <AppFilterDateRange
      ref="dateRangeFilter"
      v-show="showCalendar"
      v-on:filter-data-change="onFilterDateChange" />

    <button v-show="showExportCSV" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning">
      Export CSV
    </button>

    <AppTable 
      ref="pageTable" 
      v-bind:tableParameter="PARAM" 
      v-bind:permission="permission"/>

    <TemplateFeedback class="m-t" ref="pageFeedback" />

  </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

let PARAM = [
{
  key: 'customer',
  text: 'Account Holder',
  table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
    let parameterItem = dataParameter[parameterIndex];
    let dataItem = dataResult[dataIndex];
    if(!dataItem.customerID) {
      return '';
    }
    if(dataItem.isCompany) {
      return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.customerID}">${dataItem.customer}</a>`;
    } else {
      return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.customerID}">${dataItem.customer}</a>`;
    }
  },
},
{
  key: 'parkinglicense',
  text: 'Parking License',
  table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
    let parameterItem = dataParameter[parameterIndex];
    let dataItem = dataResult[dataIndex];
    if(!dataItem.licenseID) {
      return '';
    }
    return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${dataItem.parkinglicense}</a>`;
  },
},
{
  key: 'customerIdentity',
  text: 'Customer Identity',
},
{
  key: 'orNum',
  text: 'OR No. / PV NO.',
  table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
    let parameterItem = dataParameter[parameterIndex];
    let dataItem = dataResult[dataIndex];
    if(!dataItem.orNum) {
      return '';
    }
    return `<a href="billOR?orID=${dataItem.id}" target="_blank">${dataItem.orNum}</a>`;
  },
},
{
  key: 'orDate',
  text: 'OR Date / PV Date',
},
{
  key: 'paymentType',
  text: 'Payment Type',
},
{
  key: 'documentNo',
  text: 'Applied Document No.',
},
{
  key: 'documentSST',
  text: 'Applied Document SST No.',
},
{
  key: 'billDate',
  text: 'Bill Date',
},
{
  key: 'issueDate',
  text: 'Issue Date',
},
{
  key: 'beforeSST',
  text: 'Amount Before SST (RM)',
},
{
  key: 'sst',
  text: 'SST Amount (RM)',
},
{
  key: 'afterSST',
  text: 'Total Amount (RM)',
},
{
  key: 'billDescription',
  text: 'Bill Description',
},
{
  key: 'referBill',
  text: 'Refer Bill',
},
{
  key: 'billType',
  text: 'Bill Type',
},
{
  key: 'refNo',
  text: 'Ref. No.',
},
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
name: "PageReportCarParkSST",
components: {
  TemplateBasic,
  TemplateButton,
  AppSearch,
  AppPaging,
  AppFilter,
  AppTable,
  AppAddButton,
  AppForm,
  AppModalForm,
  TemplateFeedback,
  AppFilterDateRange,
},
data () {
  return {
    permission : null,
    breadcrumb : [
      { name: 'Home', url: helper.WEB_URL },
      { name: 'Report' },
      { name: 'Car Park SST' },
    ],

    PARAM,
    PARAM_MAP,

    pageStaff: [],
    pagePaymentMethod: [],
    pageCarpark: null,
    pageCustomer: null,
    pageBill: null,
    pageSeasonFees: {},
    pageReport: null,

    showExportCSV: false,
    showCalendar: false,
  }
},
mounted() {
  if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
    return;
  }
  
  this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
  this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
  this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('month');
  this.loadCarpark();
},
methods: {
  loadCarpark() {
    let feedbackItem = 'car park data';
    this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

    this.$http
      .get(
        helper.SERVER_URL + '/api2/carpark/',
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.pageCarpark = response.data;
        this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
        this.showCalendar = true;
        this.loadSeason();
      })
      .catch(error => {
        this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      });
  },
  loadSeason() {
    let feedbackItem = 'car park product data';
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    let url = helper.SERVER_URL + '/api2';
    if(this.$refs['carparkFilter'].filterValue) {
      url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
    }
    url += '/season/';
    
    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        if(response.data && response.data.length > 0) {
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageSeason = response.data;
          this.loadCustomer();
        } else {
          this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
        }
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  loadCustomer() {
    let feedbackItem = 'customer data'
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    let url = helper.SERVER_URL + '/api2';
    // if(this.$refs['carparkFilter'].filterValue) {
    //   url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
    // }
    url += '/customer/';
    
    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        if(response.data && response.data.length > 0) {
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadLicense();
        } else {
          this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
        }
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  loadLicense() {
    let feedbackItem = 'license data'
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    let url = helper.SERVER_URL + '/api2';
    if(this.$refs['carparkFilter'].filterValue) {
      url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
    }
    url += '/license/';
    
    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        if(response.data && response.data.length > 0) {
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageLicense = response.data;
          this.loadCollection();
        } else {
          this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
        }
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  loadCollection() {
    let startDate = this.$refs['dateRangeFilter'].filterDateStart;
    let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

    this.$refs['pageTable'].setTableData(null);
    
    let feedbackItem = 'collection data';
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    let url = helper.SERVER_URL + '/api2/collection?1=1';
    if(this.$refs['carparkFilter'].filterValue) {
      url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
    }

    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage('');

        response.data = response.data.filter(k => {
          if(this.$refs['carparkFilter'].filterValue) {
            if(!helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue)) {
              return false;
            }
          }
          return true;
        });
        
        let temp = {};
        // response.data = response.data.filter(k => {
        //   if(!k.paidDate) {
        //     return false;
        //   }
        //   if(k.paidDate < startDate.unix()) {
        //     return false;
        //   }
        //   if(k.paidDate > endDate.unix()) {
        //     return false;
        //   }
        //   return true;
        // })

        this.pageInvoiceCollectionMap = {}
        response.data.forEach(k => {
          let type = k['type'];
          if(type.endsWith('INV')) {
            k['_type'] = 'invoice';
          } else if(type.endsWith('CN')) {
            k['_type'] = 'creditNote';
          } else if(type.endsWith('DN')) {
            k['_type'] = 'debitNote';
          }

          try {
            k['_dataRef'] = JSON.parse(k['data']);
          } catch(e) {              
          }

          k['_license'] = this.pageLicense.find(j => j.carparkID === k.carparkID && j.customerID === k.customerID);
          k['licenseID'] = k['_license']['id'];
          k['_licenseStatus'] = k['_license']['status'];
          k['_licenseNum'] = k['_license']['licenseOperatorNum'];
          k['_carparkNum'] = k['_license']['carparkID'];
          k['_carpark'] = this.pageCarpark.find(j => j.id === k['carparkID']) || {};
          k['_carparkName'] = (k['_carpark'] || {}).name;
          k['_customer'] = this.pageCustomer.find(j => j.id === k['customerID']) || {};
          k['isCompany'] = (k['_customer'] || {}).isCompany;
          k['_customerType'] = (k['_customer'] || {}).isCompany ? 'Company' : 'Personal';

          let collectionID = k['id'];
          temp[collectionID] = temp[collectionID] || k;
          temp[collectionID]._invoice = temp[collectionID]._invoice || [];
          temp[collectionID]._invoice.push(k);
          temp[collectionID]['paymentType'] = k['paymentType'];

          this.pageInvoiceCollectionMap[k.invoiceID] = k
        });

        this.pageCollection = Object.keys(temp).map(k => temp[k]);

        this.loadOR();
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  loadOR() {
    let startDate = this.$refs['dateRangeFilter'].filterDateStart;
    let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

    let feedbackItem = 'official receipt data';
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    let url = helper.SERVER_URL + '/api2/receipt?1=1';
    if(this.$refs['carparkFilter'].filterValue) {
      url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
    }
    // url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
    // url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
    url += '&sort=createDate';
    
    this.pageCollectionORMap = {}
    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage('');

        // // TODO OR doesn't have carparkID, recover this after fix
        // response.data = response.data.filter(k => {
        //   if(this.$refs['carparkFilter'].filterValue) {
        //     if(!helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue)) {
        //       return false;
        //     }
        //   }
        //   if(this.$refs['licenseFilter'].filterValue) {
        //     let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
        //     if(!helper.compareID(k.customerID, license.customerID)) {
        //       return false;
        //     }
        //   }
        //   return true;
        // });
        
        let temp = {};
        response.data = response.data.filter(k => {
          if(!k.createDate) {
            return false;
          }
          if(k.createDate < startDate.unix()) {
            return false;
          }
          if(k.createDate > endDate.unix()) {
            return false;
          }

          k['_collection'] = this.pageCollection.find(j => j.id === k['collectionID']);

          if(!k['_collection']) return false;

          k['paymentType'] = k['_collection']['paymentType'];
          k['carparkID'] = k['_collection']['carparkID'];
          if(this.$refs['carparkFilter'].filterValue) {
            if(!helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue)) {
              return false;
            }
          }

          this.pageCollectionORMap[k.collectionID] = k
          return true;
        })

        this.pageOR = response.data;
        this.loadPaymentVoucher();
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  loadPaymentVoucher() {
    let startDate = this.$refs['dateRangeFilter'].filterDateStart;
    let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

    let feedbackItem = 'payment voucher data';
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    let url = helper.SERVER_URL + '/api2/requestgroup?type1=terminationRefundRequest';
    if(this.$refs['carparkFilter'].filterValue) {
      url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
    }
    url += '&sort=createDate';
    
    this.pagePV = {}
    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage('');
        
        let temp = {};
        response.data = response.data.filter(k => {
          if(!k.date4) {
            return false;
          }
          if(k.date4 < startDate.unix()) {
            return false;
          }
          if(k.date4 > endDate.unix()) {
            return false;
          }

          try {
            k['_dataRef'] = JSON.parse(k['dataRef']);
          } catch(e) {              
          }

          this.pagePV[k.licenseID] = k
        })

        this.loadInvoice();
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  loadInvoice() {
    let startDate = this.$refs['dateRangeFilter'].filterDateStart;
    let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

    let feedbackItem = 'invoice data';
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    let url = helper.SERVER_URL + '/api2/invoice?billType=INV';
    if(this.$refs['carparkFilter'].filterValue) {
      url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
    }
    url += '&sort=createDate';
    
    this.pageBill = {}
    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage('');
        
        let temp = {};
        response.data = response.data.filter(k => {
          try {
            k['_dataRef'] = JSON.parse(k['dataRef']);
          } catch(e) {              
          }

          this.pageBill[k.id] = k
        })

        this.loadDebitNote();
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  loadDebitNote() {
    let startDate = this.$refs['dateRangeFilter'].filterDateStart;
    let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

    let feedbackItem = 'debit note data';
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    let url = helper.SERVER_URL + '/api2/invoice?billType=DN';
    if(this.$refs['carparkFilter'].filterValue) {
      url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
    }
    url += '&sort=createDate';
    
    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage('');
        
        let temp = {};
        response.data = response.data.filter(k => {
          try {
            k['_dataRef'] = JSON.parse(k['dataRef']);
          } catch(e) {              
          }

          this.pageBill[k.id] = k
        })

        this.loadCreditNote();
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },
  loadCreditNote() {
    let startDate = this.$refs['dateRangeFilter'].filterDateStart;
    let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

    let feedbackItem = 'credit note data';
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    let url = helper.SERVER_URL + '/api2/invoice?billType=CN';
    if(this.$refs['carparkFilter'].filterValue) {
      url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
    }
    url += '&sort=createDate';
    
    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage('');
        
        let temp = {};
        response.data = response.data.filter(k => {
          try {
            k['_dataRef'] = JSON.parse(k['dataRef']);
          } catch(e) {      
          }

          this.pageBill[k.id] = k
        })

        this.loadInvoiceLease();
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },

  loadInvoiceLease() {
    let startDate = this.$refs['dateRangeFilter'].filterDateStart;
    let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

    let feedbackItem = 'invoice data';
    this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

    let url = helper.SERVER_URL + '/api2/invoiceLease?1=1';
    if(this.$refs['carparkFilter'].filterValue) {
      url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
    }
    
    this.$http
      .get(
        url,
        helper.createAxiosConfig()
      )
      .then(response => {
        let resultMeta = helper.processAxiosResponse(this, response);
        this.$refs['pageFeedback'].setFeedbackMessage('');

        this.pageInvoiceLease = response.data;
        this.processReport();
      })
      .catch(error => {
        this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
      })
  },

  async processReport1() {
    let result = [];

    for(let index in this.pageOR) {
      let k = this.pageOR[index];
      let temp = k;

      temp['parker'] = 0;
      temp['deposit'] = 0;
      temp['estbFee'] = 0;
      temp['parkingFee'] = 0
      temp['total'] = 0;
      let parkerList = [];

      for(let collectionInvoices of k['_collection']['_invoice']) {
        // let feedbackItem = 'invoice detail'
        // this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        // collectionInvoices['invoiceLease'] = await this.$http
        //   .get(
        //     helper.SERVER_URL + '/api2/invoiceLease/?invoiceID=' + collectionInvoices['invoiceID'],
        //     helper.createAxiosConfig()
        //   )
        //   .then(response => {
        //     let resultMeta = helper.processAxiosResponse(this, response);
        //     if(response.data && response.data.length > 0) {
        //       this.$refs['pageFeedback'].setFeedbackMessage();
        //       return response.data;
        //     } else {
        //       this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
        //     }
        //   })
        //   .catch(error => {
        //     this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        //   })

        collectionInvoices['invoiceLease'] = this.pageInvoiceLease.filter(k => helper.compareID(k.invoiceID, collectionInvoices.invoiceID))

        if(!collectionInvoices['invoiceLease']) {
          return;
        }

        
        for(let invoiceRecord of collectionInvoices['invoiceLease']) {
          let record = {};
          record['documentNo'] = helper.plBillNum(collectionInvoices.creditNum || collectionInvoices.debitNum || collectionInvoices.invoiceNum, collectionInvoices.carparkID, collectionInvoices['type']);
          collectionInvoices['_dataRef'] = collectionInvoices['_dataRef'] || {}
          record['documentSST'] = collectionInvoices['_dataRef'].sstNo;
          record['billDate'] = helper.formatDate(collectionInvoices['_dataRef'].billingDate);
          record['issueDate'] = helper.formatDate(collectionInvoices['createDate']);
          record['beforeSST'] = invoiceRecord['exclusive'];
          record['sst'] = invoiceRecord['sst'] || 0;
          record['afterSST'] = invoiceRecord['inclusive'];
          record['billDescription'] = collectionInvoices['_dataRef'].description;
          if(collectionInvoices['type'] === 'Deposit INV') {
            record['billType'] = 'DEPOSIT'
          } else if(invoiceRecord['type'] === 'ESTB Fee INV') {
            record['billType'] = 'ESTB FEE';
          } else if(invoiceRecord['type'] === 'INIT Fee INV') {
            record['billType'] = 'INIT FEE';
          } else if(invoiceRecord['type'] === 'Monthly Fee INV') {
            record['billType'] = 'MONTHLY FEE';
          } else if(collectionInvoices['type'] === 'Rev Deposit CN') {
            record['billType'] = 'REV DEPOSIT'
          } else if(invoiceRecord['type'] === 'Rev ESTB Fee CN') {
            record['billType'] = 'REV ESTB FEE';
          } else if(invoiceRecord['type'] === 'Rev INIT Fee CN') {
            record['billType'] = 'REV INIT FEE';
          } else if(invoiceRecord['type'] === 'Rev Monthly Fee CN') {
            record['billType'] = 'REV MONTHLY FEE';
          } else {
            let lastSpace = collectionInvoices['type'].lastIndexOf(' ')
            if (lastSpace > 0) {
              try {
                record['billType'] = collectionInvoices['type'].substring(0, lastSpace).toUpperCase()
              } catch(e) {
              }
            }
          }
          record['refNo'] = collectionInvoices['id'];

          let customerID = record['customerID'] = k.customerID;
          record['_customer'] = this.pageCustomer.find(j => j.id === customerID) || {};
          record['isCompany'] = record['_customer'].isCompany;
          record['customer'] = record['_customer']['name'];
          record['customerIdentity'] = record['_customer']['nationalID'];
          let carparkID = k.carparkID;
          record['_carpark'] = this.pageCarpark.find(j => j.id === carparkID) || {};
          record['_license'] = this.pageLicense.find(j => j.customerID === customerID && j.carparkID === carparkID) || {};
          record['licenseID'] = record['_license'].id;
          record['parkinglicense'] = helper.plFormPLNum(record['_license'].licenseOperatorNum, carparkID);
          record['orNum'] = helper.plORNum(k.receiptNum, carparkID);
          record['orDate'] = helper.formatDate(k.createDate);
          record['paymentType'] = temp['paymentType']

          if (record['documentNo'].startsWith('CN')) {
            record['beforeSST'] = helper.formatMoney(0 - record['beforeSST'])
            record['sst'] = helper.formatMoney(0 - record['sst'])
            record['afterSST'] = helper.formatMoney(0 - record['afterSST'])
          }

          result.push(record);
        }
      }
    }

    this.finalResult = result;

    if(this.finalResult.length > 0) {
      // this.$refs['pageTable'].setTableData(result);
      this.showExportCSV = true;
    } else {
      this.$refs['pageTable'].setTableData([]);
    }
  },

  async processReport() {
    let result = [];

    let sum = {
      _summary: true,
      beforeSST: 0,
      sst: 0,
      afterSST: 0,
    }
    for(let invoiceRecord of this.pageInvoiceLease) {
      let receipt
      let pv

      let collectionInvoices = this.pageInvoiceCollectionMap[invoiceRecord.invoiceID]
      if (collectionInvoices) {
        receipt = this.pageCollectionORMap[collectionInvoices.id]
      }

      if (!receipt) {
        collectionInvoices = null
        
        pv = this.pagePV[invoiceRecord.licenseID]
        if (pv) {
          let pvDate = pv['date4']
          if (pvDate) {
            pvDate -= 10 * 60
            let bill = this.pageBill[invoiceRecord.invoiceID]
            if (!bill.voidDate && (bill.paidDate >= pvDate || bill.usedDate >= pvDate)) {
              // paid/used after PV complete, need include in SST report
              collectionInvoices = bill
            }
          }
        }
      }

      if (!collectionInvoices) {
        continue
      }

      let record = {};
      record['documentNo'] = helper.plBillNum(collectionInvoices.creditNum || collectionInvoices.debitNum || collectionInvoices.invoiceNum, collectionInvoices.carparkID, collectionInvoices['type']);
      collectionInvoices['_dataRef'] = collectionInvoices['_dataRef'] || {}
      record['documentSST'] = collectionInvoices['_dataRef'].sstNo;
      record['billDate'] = helper.formatDate(collectionInvoices['_dataRef'].billingDate);
      record['issueDate'] = helper.formatDate(collectionInvoices['createDate']);
      record['beforeSST'] = invoiceRecord['exclusive'];
      record['sst'] = invoiceRecord['sst'] || 0;
      record['afterSST'] = invoiceRecord['inclusive'];
      record['billDescription'] = collectionInvoices['_dataRef'].description;
      if(invoiceRecord['type'] === 'Deposit INV') {
        record['billType'] = 'DEPOSIT'
      } else if(invoiceRecord['type'] === 'ESTB Fee INV') {
        record['billType'] = 'ESTB FEE';
      } else if(invoiceRecord['type'] === 'INIT Fee INV') {
        record['billType'] = 'INIT FEE';
      } else if(invoiceRecord['type'] === 'Monthly Fee INV') {
        record['billType'] = 'MONTHLY FEE';
      } else if(invoiceRecord['type'] === 'Rev Deposit CN') {
        record['billType'] = 'REV DEPOSIT'
      } else if(invoiceRecord['type'] === 'Rev ESTB Fee CN') {
        record['billType'] = 'REV ESTB FEE';
      } else if(invoiceRecord['type'] === 'Rev INIT Fee CN') {
        record['billType'] = 'REV INIT FEE';
      } else if(invoiceRecord['type'] === 'Rev Monthly Fee CN') {
        record['billType'] = 'REV MONTHLY FEE';
      } else {
        let lastSpace = collectionInvoices['type'].lastIndexOf(' ')
        if (lastSpace > 0) {
          try {
            record['billType'] = collectionInvoices['type'].substring(0, lastSpace).toUpperCase()
          } catch(e) {
          }
        }
      }
      record['refNo'] = collectionInvoices['id'];

      let customerID = record['customerID'] = collectionInvoices.customerID;
      record['_customer'] = this.pageCustomer.find(j => j.id === customerID) || {};
      record['isCompany'] = record['_customer'].isCompany;
      record['customer'] = record['_customer']['name'];
      record['customerIdentity'] = record['_customer']['nationalID'];
      let carparkID = collectionInvoices.carparkID;
      record['_carpark'] = this.pageCarpark.find(j => j.id === carparkID) || {};
      record['_license'] = this.pageLicense.find(j => j.customerID === customerID && j.carparkID === carparkID) || {};
      record['licenseID'] = record['_license'].id;
      record['parkinglicense'] = helper.plFormPLNum(record['_license'].licenseOperatorNum, carparkID);

      record['orNum'] = ''
      record['orDate'] = ''
      record['paymentType'] = ''
      if (receipt) {
        record['orNum'] = helper.plORNum(receipt.receiptNum, carparkID);
        record['orDate'] = helper.formatDate(receipt.createDate);
        record['paymentType'] = receipt['paymentType']
      } else if (pv) {
        record['orNum'] = helper.plFormPVNum(pv.applicationID, carparkID)
        record['orDate'] = helper.formatDate(pv.date4);

        let paymentType = 'NA'
        // if(pv['_dataRef']['refundMethod'] === '0') {
        //   paymentType = 'GIRO'
        // } else if(pv['_dataRef']['refundMethod'] === '1') {
        //   paymentType = 'Cheque'
        // }

        record['paymentType'] = paymentType
      }

      if (record['documentNo'].startsWith('CN')) {
        record['beforeSST'] = helper.formatMoney(0 - record['beforeSST'])
        record['sst'] = helper.formatMoney(0 - record['sst'])
        record['afterSST'] = helper.formatMoney(0 - record['afterSST'])

        record['referBill'] = `INV${carparkID}-${collectionInvoices['_dataRef'].reverseInvoiceNum}`
      } else if (record['documentNo'].startsWith('DN')) {
        record['referBill'] = `INV${carparkID}-${collectionInvoices['_dataRef'].reverseInvoiceNum}`
      }

      sum['beforeSST'] += parseFloat(record['beforeSST'])
      sum['sst'] += parseFloat(record['sst'])
      sum['afterSST'] += parseFloat(record['afterSST'])

      result.push(record);
    }

    result.push(sum);

    this.finalResult = result;

    if(this.finalResult.length > 0) {
      // this.$refs['pageTable'].setTableData(result);
      this.showExportCSV = true;
    } else {
      this.$refs['pageTable'].setTableData([]);
    }
  },

  onFilterCarparkChange(dataIndex) {
    this.showExportCSV = false;
    this.pageReport = null;
    this.$refs['pageTable'].setTableData(null);
    this.loadSeason();
  },
  onFilterDateChange(dataIndex) {
    this.showExportCSV = false;
    this.pageReport = null;
    this.$refs['pageTable'].setTableData(null);
    this.loadCollection();
  },

  onFormInput(formData, formParameter, input) {
    if(formParameter.key === 'paymethodID') {
      let paymentMethod = formData[formParameter.key];
      if(paymentMethod === this.paymentMethodIDGiro) {
        // giro
        this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = false;
        this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = false;
        this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
        this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
        this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
      } else if(paymentMethod === this.paymentMethodIDCheque) {
        // cheque
        this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
        this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
        this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = false;
        this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = false;
        this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = false;
      } else { 
        // cash?
        this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
        this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
        this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
        this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
        this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
      }
    } else if(formParameter.key === 'staffID') {
      let staff = helper.inputSelectFindOption(this.PAYMENT_PARAM_MAP['staffID'], formData['staffID'])
      formData['staffNo'] = staff['personnelCode'];
    }
  },
  onCSVButtonClick() {
    let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue))
    let startDate = this.$refs['dateRangeFilter'].filterDateStart;
    let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

    var header = [];
    if(carpark) {
      header.push('Car Park Code: ' + carpark.carparkCode)
      header.push('Car Park: ' + carpark.name)
    }
    header.push('REPORT : CAR PARK SST FOR THE MONTH - ' + (startDate.month() + 1) + '/' + startDate.year())

    // printCSV('#jt-table', `Report Car Park SST ${(startDate.month() + 1) + '/' + startDate.year()}`, header);
    printCSVjson('#jt-table', `Report Car Park SST ${(startDate.month() + 1) + '/' + startDate.year()}`, header, this.finalResult, this.PARAM, true);
  }
},
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportCarParkSST.vue